module.exports = __webpack_public_path__ + "img/close.26dcbada.svg";